/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const RESERVED_ATTRIBUTE_NAMES = ["email", "first name", "last name", "phone number", "unsubscribed", "date added", "first source", "timezone", "last bulk email", "last applied", "last invited", "last participated", "total incentives earned"];
